import { gql } from "@apollo/client";

import CommonRecognitionArtifactFragment from "@graphql/common-recognition-artifact-fragment";

export default gql`
  ${CommonRecognitionArtifactFragment}
  query getMeetingRecognitionsNewPageQuery(
    $recognitionRecipients: [Int]
    $createdByIds: [Int]
    $meetingGroupId: Int
    $fetchData: Boolean!
    $after: String
    $first: Int!
  ) {
    artifacts(
      artifactType: recognition
      first: $first
      orderBy: "-created"
      meetingGroupId: $meetingGroupId
      recognitionRecipients: $recognitionRecipients
      createdByIds: $createdByIds
      after: $after
    ) {
      pageInfo {
        hasNextPage
        endCursor
      }
      totalCount
      edges @include(if: $fetchData) {
        node {
          id
          canDelete {
            permission
          }
          canUpdate {
            permission
          }
          created
          ...CommonRecognitionArtifactFragment
        }
      }
    }
  }
`;
